import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BannerImg from "../../../images/locationgcc/bh/Bahrainblack.webp";

function whychoose(props) {
  return (
    <div
      className="whychoose p-100"
      style={{ backgroundImage: `url(${BannerImg})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={5} xl={5} xxl={5}>
            <h2>Achieve Excellence in Your Business Field with <span>TekRevol</span> - Why Choose Us?</h2>
            <p>
            TekRevol is a mobile app development company Bahrain that assures clients by developing robust and top-tier software products aligned with their organizational goals. Our app development services include native and cross-platform apps for both iOS and Android platforms. Having a firm grip on the latest technologies for mobile app development, we build applications that outperform in the long run.
            </p>
            <p>
            With strong confidence in our service quality, we encourage clients to outsource their app development by delegating their projects to us. We have all the required resources to create state-of-the-art applications for internal and external business objectives. 
            </p>
          </Col>
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="offset-xl-1">
            <div className="choose-main">
              <div className="choose-box">
                <div className="choose-num">
                  300+<span>Apps Developed</span>
                </div>
              </div>
              <div className="choose-box">
                <div className="choose-num">
                  65+<span>Review</span>
                </div>
              </div>
              <div className="choose-box">
                <div className="choose-num">
                  35+<span>Industries Served</span>
                </div>
              </div>
            </div>
            <h5>Process Automation</h5>
            <p>
            Simplify your work process with our mobile app development Bahrain as we automate those repetitive tasks, giving you room to focus on what truly matters. Our tech-savvy solutions enhance efficiency, by streamlining the hectic workflow.
            </p>
            <h5>Revenue Generation</h5>
            <p>
            Our mobile app development services will help you to boost your earnings. We craft user-centric applications with premium features, turning your app into a revenue-generating powerhouse.
            </p>
            <h5>Business Scalability</h5>
            <p>
            Grow effortlessly with our app development Bahrain as our app solutions are built to evolve alongside your business. So, you can embrace the future without worrying about limitations – we've got your back.
            </p>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default whychoose;
